import { BreadCrumbModel } from '@/models/breadcrumb';
import i18n from '@/plugins/i18n';

const Breadcrumbs = {
  portalServices: [{
    text: i18n.t('portalServices.title'),
    href: '/services',
  }] as BreadCrumbModel[],

  licenseGuide: [{
    text: i18n.t('router.licenseGuide'),
    href: '/license-guide',
  }] as BreadCrumbModel[],

  faq: [{
    text: i18n.t('faq'),
    href: '/faq',
  }] as BreadCrumbModel[],

  serviceDetails: [{
    text: i18n.t('portalServices.title'),
    href: '/e-services/',
  },
  {
    text: i18n.t('portalServices.readMore'),
    href: '/e-services/:serviceId',
  }] as BreadCrumbModel[],

  notifications: [{
    text: i18n.t('router.notifications'),
    href: '/notifications',
  }] as BreadCrumbModel[],

  searchResult: [{
    text: i18n.t('router.theSearch'),
    href: '/',
  }] as BreadCrumbModel[],
};
export default Breadcrumbs;
